import Vue from 'vue';
import injector from 'vue-inject';
import store from '../store';

require('./api');
require('./popup');

let api     = injector.get('api'),
    popup   = injector.get('popup');

class MonthlyStatement {
    fetchData() {
        return new Promise((resolve, reject) => {
            Vue.http.get(api.commissions.list)
                .then(response => {
                    store.commit('setMonthlyStatement', response.body.results);
                    resolve ();
                }, error => {
                    if (error.data && error.data.errors) {
                        popup.show(error.data.errors[0].message);
                    }
                    reject ();
                });
        });
    }
    getDownloadLink(period) {
        return API + api.commissions.download(period)
    }
}

injector.service('monthlyStatement', MonthlyStatement);



// WEBPACK FOOTER //
// ./src/services/monthlyStatement.js